"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DraggableMenu;
var _core = require("@dnd-kit/core");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var activationConstraint = {
  // Press delay of 100ms, with tolerance of 2px of movement
  delay: 100,
  tolerance: 2
};
function DraggableMenu(props) {
  var mouseSensor = (0, _core.useSensor)(_core.MouseSensor, {
    activationConstraint: activationConstraint
  });
  var touchSensor = (0, _core.useSensor)(_core.TouchSensor, {
    activationConstraint: activationConstraint
  });
  var sensors = (0, _core.useSensors)(mouseSensor, touchSensor);
  return /*#__PURE__*/_react.default.createElement(_core.DndContext, _extends({
    sensors: sensors
  }, props), props.children);
}